// var swiper = new Swiper(".custom-banner-slider", {
//       spaceBetween: 0,
//       centeredSlides: true,
//       loop: true,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//   });

// hero slider start //

var swiper = new Swiper(".custom-hero-slider", {
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
  });

// hero slider end //  

var swiper = new Swiper(".custom-banner-slider", {
  slidesPerView: 5,          // 👈 Show 4 videos per slide
  spaceBetween: 20,          // Adjust spacing between videos
  loop: true,
  centeredSlides: false,  // Don’t center them since there are multiple
  autoplay: true,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
  breakpoints: {             // 👇 Make it responsive
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    560:{
        slidesPerView: 3,
        spaceBetween: 15,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

// Fallback: if video element exists but not wrapped in anchor (no product selected),
// do nothing. If product_url present on slide, clicking anywhere on slide navigates.
  document.querySelectorAll('.custom-banner-slider .swiper-slide').forEach(function(slide){
    var url = slide.getAttribute('data-product-url');
    if (url && url !== 'null' && url !== '') {
      // if a link already wraps the video, clicks will follow it automatically.
      // add a click listener on slide as backup (also covers clicking outside video inside slide).
      slide.addEventListener('click', function(e){
        // if clicked an actual anchor or a link handled by browser, let it be
        var target = e.target;
        if (target && (target.closest && target.closest('a'))) return;
        // else navigate
        window.location.href = url;
      });
    }
  });